module.exports = __webpack_public_path__ + "media/images/web/home/index/congress-328057437a38f0c518c60db702e4413a.webp";